import { atom , selector ,atomFamily } from "recoil";      
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
    key:'overLimitPerWalletState',
    storage:sessionStorage,
});

export const overLimitPerWalletState = atom({
    key: "overLimitPerWalletState",
    default:'',
    effects_UNSTABLE:[persistAtom],
});

